import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useMemo } from 'react';
import { Grid, IconButton, Typography } from '@mui/material';
import { MaterialDropdown } from 'console/shared/components/fields';
import { ControlWithoutLabel } from 'console/shared/components/fields/control/without-label';
import { RadioSensor, WiredTemperatureSensor, } from 'z3k-config';
import { temperature_from_state, get_thermometer_state } from 'z3k-parser/lib';
import { unpack_validation, } from 'webui/Z3KConfigParser/validation/types';
import { Delete } from '@mui/icons-material';
import { TextInputWrapper } from 'console/shared/components/fields/text';
import { formatTemp } from 'utils';
import { ThermometerState } from 'webui/utils/thermometers';
export function gen_circuit_dropdown_options(circuit_options, current) {
    const out = [{ text: 'Не назначен', value: null }];
    let found = false;
    for (const co of circuit_options) {
        out.push({ text: co.name, value: co.circuit_id });
        if (co.circuit_id == current)
            found = true;
    }
    if (!found && current != undefined)
        out.push({ text: 'ошибка', value: current });
    return out;
}
const WiredSensorRow = memo(function WiredSensorRow(props) {
    const { circuit_options, setting, validation, state, delete_enabled, onChange, onDelete, } = props;
    const is_radio_sensor_no_connect = RadioSensor.isNoConnect(state);
    const status = useMemo(() => get_thermometer_state(state, is_radio_sensor_no_connect), [state, is_radio_sensor_no_connect]);
    const { not_connected, malfunction } = useMemo(() => {
        const not_connected = status === ThermometerState.not_connected;
        const malfunction = status === ThermometerState.malfunction;
        return { not_connected, malfunction };
    }, [state]);
    const name_validation = unpack_validation(validation, 'name');
    const circuit_validation = unpack_validation(validation, 'circuit_id');
    return (_jsxs(Grid, { item: true, container: true, xs: 12, spacing: 2, alignItems: "center", children: [_jsx(Grid, { item: true, xs: 3, children: _jsx(ControlWithoutLabel, { value: setting.name, validation_result: name_validation, validation_warnings_result: null, onChange: (name) => {
                        onChange({ name });
                    }, field: TextInputWrapper }) }), not_connected ? (_jsx(Grid, { item: true, xs: 4, children: _jsx(Typography, { variant: "body2", color: "error", children: "\u041D\u0435\u0442 \u0441\u0432\u044F\u0437\u0438 \u0441 \u0434\u0430\u0442\u0447\u0438\u043A\u043E\u043C" }) })) : malfunction ? (_jsx(Grid, { item: true, xs: 4, children: _jsx(Typography, { variant: "body2", color: "error", children: "\u0414\u0430\u0442\u0447\u0438\u043A \u043D\u0435\u0438\u0441\u043F\u0440\u0430\u0432\u0435\u043D" }) })) : (_jsx(Grid, { item: true, xs: 4, children: _jsx(Typography, { children: formatTemp(state ? temperature_from_state(state) : null) }) })), _jsx(Grid, { item: true, xs: 4, children: _jsx(ControlWithoutLabel, { validation_result: circuit_validation, validation_warnings_result: null, value: setting?.circuit_id || null, onChange: (value) => {
                        if (value === null)
                            onChange({ circuit_id: undefined });
                        else
                            onChange({
                                circuit_id: value,
                            });
                    }, field: (input_props) => (_jsx(MaterialDropdown, { disabled: !WiredTemperatureSensor.isRealSensor(setting), defaultValue: setting?.circuit_id ?? '', options: gen_circuit_dropdown_options(circuit_options, setting.circuit_id), ...input_props })) }) }), _jsx(Grid, { item: true, xs: 1, children: _jsx(IconButton, { disabled: !delete_enabled, size: "small", title: delete_enabled
                        ? 'Удалить датчик'
                        : 'Устройство не на связи, функция недоступна', onClick: onDelete, children: _jsx(Delete, {}) }) })] }));
});
export { WiredSensorRow };
